export enum PERMISSIONS {
  Aprobar = "Aprobar",
  Crear = "Crear",
  Editar = "Editar",
  Ejecutar = "Ejecutar",
  Eliminar = "Eliminar",
  Lectura = "Lectura"
}

export const DEFAULT_ACTIONS = {
  [PERMISSIONS.Aprobar]: false,
  [PERMISSIONS.Crear]: false,
  [PERMISSIONS.Editar]: false,
  [PERMISSIONS.Ejecutar]: false,
  [PERMISSIONS.Eliminar]: false,
  [PERMISSIONS.Lectura]: false
}

export const ACTIONS_ADMIN = {
  [PERMISSIONS.Aprobar]: true,
  [PERMISSIONS.Crear]: true,
  [PERMISSIONS.Editar]: true,
  [PERMISSIONS.Ejecutar]: true,
  [PERMISSIONS.Eliminar]: true,
  [PERMISSIONS.Lectura]: true
}